<template>
    <div id="login">
        <loader></loader>
        <div class="header">
            <h1>Identification</h1>
        </div>
        <form class="large">
            <div class="medium">
                <label for="nomUtilisateur" >Nom d'utilisateur</label>
                <input type="text" v-model="login" id="nomUtilisateur" @keyup.enter="connect">
            </div>

            <div  class="medium">
                <div class="passwordView">
                    <label for="mdp">Mot de passe</label>
                    <svg @mousedown="togglePassword(1)" @mouseup="togglePassword(0)" @mouseout="togglePassword(0)">
                        <use xlink:href="#icon-eye"></use>
                    </svg>
                </div>
                <input :type="passwordType" v-model="password" id="mdp" @keyup.enter="connect">
            </div>
        </form>
        <div class="pageOptions">
            <a class="btn blue" @click="connect">
                Se connecter
            </a>
        </div>
        <svg style="position:absolute;width:0;height:0;overflow:hidden">
            <defs>
                <symbol id="icon-eye" viewBox="0 0 15 10">
                    <title>icon-eye</title>
                    <path d="M7.5 2.08333C7.22399 2.08765 6.95002 2.1315 6.68646 2.21354C6.80837 2.42795 6.87329 2.67003 6.875 2.91667C6.875 3.10818 6.83728 3.29781 6.76399 3.47475C6.6907 3.65168 6.58328 3.81245 6.44786 3.94786C6.31244 4.08328 6.15168 4.1907 5.97474 4.26399C5.79781 4.33728 5.60817 4.375 5.41666 4.375C5.17002 4.37329 4.92794 4.30837 4.71354 4.18646C4.54438 4.77312 4.56409 5.39814 4.76989 5.97298C4.97569 6.54782 5.35713 7.04333 5.8602 7.38934C6.36326 7.73534 6.96244 7.91429 7.57286 7.90084C8.18327 7.88739 8.77399 7.68223 9.26133 7.3144C9.74866 6.94658 10.1079 6.43474 10.2882 5.8514C10.4685 5.26806 10.4606 4.64278 10.2658 4.06413C10.071 3.48549 9.69902 2.98281 9.20263 2.62731C8.70623 2.2718 8.11056 2.08149 7.5 2.08333ZM14.9094 4.61979C13.4971 1.86432 10.7013 0 7.5 0C4.29869 0 1.50207 1.86563 0.0906109 4.62005C0.0310384 4.73789 0 4.86809 0 5.00013C0 5.13217 0.0310384 5.26237 0.0906109 5.38021C1.50285 8.13568 4.29869 10 7.5 10C10.7013 10 13.4979 8.13437 14.9094 5.37995C14.969 5.26211 15 5.13191 15 4.99987C15 4.86783 14.969 4.73763 14.9094 4.61979ZM7.5 8.75C4.93098 8.75 2.57577 7.31771 1.30389 5C2.57577 2.68229 4.93072 1.25 7.5 1.25C10.0693 1.25 12.4242 2.68229 13.6961 5C12.4245 7.31771 10.0693 8.75 7.5 8.75Z"/>
                </symbol>
            </defs>
        </svg>
    </div>
</template>

<script>
    import Loader from "@/components/Loader";
    import store from '../store'
    import axios from 'axios';
    import tools from '../config.ts';

    export default {
        name: "Login",
        components: {Loader},
        store,
        data() {
            return{
                passwordType:'password',
                login:"",
                password:"",
            }
        },
        methods: {
            connect() {

                tools.loader(true);
                // Chargement de l'utilisateur
                axios.post(tools.api("user/auth"),tools.toPOST({
                    login:this.login,
                    password:this.password,
                }),tools.headerPOST())
                    .then((response) => {

                        this.$store.commit("loginSuccess",{
                            user:response.data,
                            token:response.data.token,
                            permissions:response.data.permissions
                        });

                        tools.loader(false);
                        this.$router.push("calls");

                    })
                    .catch((e) => {
                        tools.loader(false);
                        tools.popup("valid",{
                            title : "Connexion",
                            message : "Login ou mot de passe incorrect",
                        })
                    })
            },
            togglePassword(toggle){
                this.passwordType = toggle?'input':'password'
            }
        }
    }
</script>
